/* eslint-disable */
const helper = {};

/**
 * 和App交互需要拼接全路径
 */
helper.splicingURL = process.env.VUE_APP_CURENV


/**
 * 存储数据
 */
helper.sessionData = (color, bool) => {
  let status = JSON.parse(localStorage.getItem('status'));
  status.push(`${color}_${bool}`);
  localStorage.setItem('status', JSON.stringify(status))

  helper.callModule('showNavigationBar', color);
  helper.callModule('hidenTabBar', bool);
}

/**
 * 销毁掉用
 */
helper.beforeDestroy = (num) => {
  let status = JSON.parse(localStorage.getItem('status'));
  let statusColor = status[status.length - num - 1];
  status.splice(status.length - num, num);
  localStorage.setItem('status', JSON.stringify(status))

  helper.callModule('showNavigationBar', statusColor.split('_')[0] === 'undefined' ? '' : statusColor.split('_')[0]);
  helper.callModule('hidenTabBar', statusColor.split('_')[1]);
}
/**
 * tabbar数据转换
 */
helper.statusBar = (num) => {
  return (sessionStorage.getItem('statusBar') ? sessionStorage.getItem('statusBar') * 1 + num : num) / 10 / 3.75
}
helper.statusBars = (num) => {
  return (sessionStorage.getItem('statusBar') ? sessionStorage.getItem('statusBar') * 1 + num : num)
}
/**
 * 和App交互
 * showNavigationBar 状态栏的颜色和显示隐藏
 * hidenTabBar tabbar的显示和隐藏
 * jumpNotice 跳转通知
 * jumpLogin 跳转登录
 */
helper.callModule = (types, keys) => {
  console.log('方法名')
  console.log(types)
  console.log('入参')
  console.log(keys)
  var u = navigator.userAgent;
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (isiOS) {
    if (window.webkit == undefined) {
      isUIWebView(types, keys);
    } else {
      isWKWebView(types, keys);
    }
  } else {
    switch (types) {
      case 'requestQRScan':
        javascript: android.requestQRScan(keys);
        break;
      case 'showNavigationBar':
        javascript: android.showNavigationBar(keys);
        break;
      case 'hidenTabBar':
        javascript: android.hidenTabBar(keys);
        break;
      case 'jumpNotice':
        javascript: android.jumpNotice(keys);
        break;
      case 'jumpLogin':
        javascript: android.jumpLogin();
        break;
      case 'jumpLogin2':
        javascript: android.jumpLogin2();
        break;	
      case 'fourkey':
        javascript: android.fourkey();
        break;
      case 'resd':
        javascript: android.resd(keys);
        break;			
      case 'jumpLogout':
        javascript: android.jumpLogout();
        break;
      case 'jumpHomePage':
        javascript: android.jumpHomePage(keys);
        break;
      case 'jumpMessage':
        javascript: android.jumpMessage();
        break;
      case 'getMessageCount':
        javascript: android.getMessageCount();
        break;
      case 'jumpMenuMore':
        javascript: android.jumpMenuMore();
        break;
      case 'isLogin':
        javascript: android.isLogin(keys);
        break;
      case 'jumpSysSetting':
        javascript: android.jumpSysSetting();
        break;
      case 'mobileShieldSign':
        javascript: android.mobileShieldSign(keys);
        break;
      case 'searchJump':
        javascript: android.searchJump();
        break;
      case 'requestAliFace':
        javascript: android.requestAliFace(keys);
        break;
      case 'requestSilentFace':
        javascript: android.requestSilentFace(keys);
        break;
      case 'querySilentFaceResult':
        javascript: android.querySilentFaceResult(keys);
        break;
      case 'requestFacePhoto':
        javascript: android.requestFacePhoto();
        break;
      case 'jumpQR':
        javascript: android.jumpQR();
        break;
      case 'jumpProtocolUser':
        javascript: android.jumpProtocol("User");
        break;
      case 'jumpProtocolPrivacy':
        javascript: android.jumpProtocol("Privacy");
        break;
      case 'requestThirdAuth':
        javascript: android.requestThirdAuth(keys);
        break;
      case 'updateUserInfo':
        javascript: android.updateUserInfo();
        break;
      case 'mobileShieldSign':
        javascript: android.mobileShieldSign(keys);
        break;
      //判断是否有手机盾，resultLocalCert为返回结果的回调函数
      case 'checkLocalCert':
        javascript: android.checkLocalCert();
        break;
      //跳转绑定手机盾页面	  
      case 'jumpMobileShield':
        javascript: android.jumpMobileShield();
        break;
      //建议或意见跳转	  
      case 'closePage':
        javascript: android.closePage();
        break;
      case 'getCaringModel':
        javascript: android.getCaringModel();
        break;	
	  case 'previewFile':
		console.log('previewFile')
		console.log(JSON.stringify(keys))
        javascript: android.previewFile(JSON.stringify(keys));
        break;		
    }
  }
}

function isUIWebView(types, keys) {
  switch (types) {
    case 'requestQRScan':
      window.requestQRScan(keys);
      break;
    case 'showNavigationBar':
      window.showNavigationBar(keys);
      break;
    case 'hidenTabBar':
      window.hidenTabBar(keys);
      //   window.webkit.messageHandlers.hidenTabBar.postMessage(keys);
      break;
    case 'jumpNotice':
      window.jumpNotice(keys);
      break;
    case 'jumpLogin':
      window.jumpLogin();
      break;
    case 'jumpLogin2':
      window.jumpLogin2();
      break;	
    case 'fourkey':
      window.fourkey();
      break;
    case 'resd':
      window.resd(keys);
      break;	  
    case 'jumpLogout':
      window.jumpLogout();
      break;
    case 'jumpHomePage':
      window.jumpHomePage(keys);
      break;
    case 'jumpMessage':
      window.jumpMessage();
      break;
    case 'getMessageCount':
      window.getMessageCount();
      break;
    case 'jumpMenuMore':
      window.jumpMenuMore();
      break;
    case 'isLogin':
      window.isLogin(keys);
      break;
    case 'jumpSysSetting':
      window.jumpSysSetting();
      break;
    case 'mobileShieldSign':
      window.mobileShieldSign(keys);
      //   window.webkit.messageHandlers.mobileShieldSign.postMessage(keys);
      break;
    case 'searchJump':
      window.searchJump();
      break;
    case 'requestAliFace':
      window.requestAliFace(keys);
      //      window.webkit.messageHandlers.requestAliFace.postMessage(keys)
      break;
    case 'requestSilentFace':
      window.requestSilentFace(keys);
      //      window.webkit.messageHandlers.requestSilentFace.postMessage(keys)
      break;
    case 'requestFacePhoto':
      window.requestFacePhoto();
      //      window.webkit.messageHandlers.requestFacePhoto.postMessage()
      break;
    case 'querySilentFaceResult':
      window.querySilentFaceResult(keys);
      //      window.webkit.messageHandlers.querySilentFaceResult.postMessage(keys)
      break;
    case 'jumpQR':
      window.jumpQR(keys);
      //      window.webkit.messageHandlers.querySilentFaceResult.postMessage(keys)
      break;
    case 'jumpProtocolUser':
      window.jumpProtocol("User");
      break;
    case 'jumpProtocolPrivacy':
      window.jumpProtocol("Privacy");
      break;
    case 'requestThirdAuth':
      window.requestThirdAuth(keys);
      break;
    case 'updateUserInfo':
      window.updateUserInfo();
      break;
    case 'mobileShieldSign':
      window.mobileShieldSign(keys);
      break;
    //判断是否有手机盾，resultLocalCert为返回结果的回调函数
    case 'checkLocalCert':
      window.checkLocalCert();
      break;
    //跳转绑定手机盾页面	  
    case 'jumpMobileShield':
      window.jumpMobileShield();
      break;
	  
    //建议或意见跳转	 
    case 'closePage':
      window.closePage();
      break;		 
    case 'getCaringModel':
      window.getCaringModel();
      break;
    case 'previewFile':
	  console.log('previewFile')
      window.previewFile(JSON.stringify(keys));
      break;	  
	  
  }
}

function isWKWebView(types, keys) {
  switch (types) {

    case 'requestQRScan':
      window.webkit.messageHandlers.requestQRScan.postMessage(keys);
      break;
    case 'showNavigationBar':
      window.webkit.messageHandlers.showNavigationBar.postMessage(keys);
      break;
    case 'hidenTabBar':
      //      window.hidenTabBar(keys);
      window.webkit.messageHandlers.hidenTabBar.postMessage(keys);
      break;
    case 'jumpNotice':
      window.webkit.messageHandlers.jumpNotice.postMessage(keys);
      break;
    case 'jumpLogin':
      window.webkit.messageHandlers.jumpLogin.postMessage("");
      break;
    case 'jumpLogin2':
      window.webkit.messageHandlers.jumpLogin2.postMessage("");
      break;	
    case 'fourkey':
      window.webkit.messageHandlers.fourkey.postMessage("");
      break;
    case 'resd':
      window.webkit.messageHandlers.resd.postMessage(keys);
      break;	  
    case 'jumpLogout':
      window.webkit.messageHandlers.jumpLogout.postMessage("");
      break;
    case 'jumpHomePage':
      window.webkit.messageHandlers.jumpHomePage.postMessage(keys);
      break;
    case 'jumpMessage':
      window.webkit.messageHandlers.jumpMessage.postMessage("");
      break;
    case 'getMessageCount':
      window.webkit.messageHandlers.getMessageCount.postMessage("");
      break;
    case 'jumpMenuMore':
      window.webkit.messageHandlers.jumpMenuMore.postMessage("");
      break;
    case 'isLogin':
      window.webkit.messageHandlers.isLogin.postMessage(keys);
      break;
    case 'jumpSysSetting':
      window.webkit.messageHandlers.jumpSysSetting.postMessage("");
      break;
    case 'mobileShieldSign':
      //     window.mobileShieldSign(keys);
      window.webkit.messageHandlers.mobileShieldSign.postMessage(keys);
      break;
    case 'searchJump':
      window.webkit.messageHandlers.searchJump.postMessage("");
      break;
    case 'requestAliFace':
      //     window.requestAliFace(keys);
      window.webkit.messageHandlers.requestAliFace.postMessage(keys)
      break;
    case 'requestSilentFace':
      //     window.requestSilentFace(keys);
      window.webkit.messageHandlers.requestSilentFace.postMessage(keys)
      break;
    case 'querySilentFaceResult':
      //     window.querySilentFaceResult(keys);
      window.webkit.messageHandlers.querySilentFaceResult.postMessage(keys)
      break;
    case 'requestFacePhoto':
      //     window.requestFacePhoto();
      window.webkit.messageHandlers.requestFacePhoto.postMessage("")
      break;
    case 'jumpQR':
      window.webkit.messageHandlers.jumpQR.postMessage("")
      break;
    case 'jumpProtocolUser':
      window.webkit.messageHandlers.jumpProtocol.postMessage("User");
      break;
    case 'jumpProtocolPrivacy':
      window.webkit.messageHandlers.jumpProtocol.postMessage("Privacy");
      break;
    case 'requestThirdAuth':
      window.webkit.messageHandlers.requestThirdAuth.postMessage(keys);
      break;
    case 'updateUserInfo':
      window.webkit.messageHandlers.updateUserInfo.postMessage("");
      break;
    case 'mobileShieldSign':
      window.webkit.messageHandlers.mobileShieldSign.postMessage(keys);
      break;
    //判断是否有手机盾，resultLocalCert为返回结果的回调函数
    case 'checkLocalCert':
      window.webkit.messageHandlers.checkLocalCert.postMessage({});
      break;
    //跳转绑定手机盾页面
    case 'jumpMobileShield':
      window.webkit.messageHandlers.jumpMobileShield.postMessage({});
      break;  
	//建议或意见跳转
    case 'closePage':
      window.webkit.messageHandlers.closePage.postMessage({});
      break;	  
    case 'getCaringModel':
      window.webkit.messageHandlers.getCaringModel.postMessage({});
      break;		  
    case 'previewFile':
	  console.log('previewFile')
      window.webkit.messageHandlers.previewFile.postMessage(JSON.stringify(keys));
      break;	
  }
}

/**
 * 获取路由参数
 */
// helper.GetQueryValue = function(queryName) {
//     var query = decodeURI(window.location.search.substring(1));
//     var vars = query.split("&");
//     for (var i = 0; i < vars.length; i++) {
//         var pair = vars[i].split("=");
//         if (pair[0] == queryName) { return pair[1]; }
//     }
//     return null;
//   }

export default helper